import { useCallback } from 'react';
import { useNavigate, type NavigateOptions, type To } from 'react-router-dom';

/**
 * Обёртка над useNavigate. Явно передавайте `{ viewTransition: true }`, если нужно
 * (в WebView Telegram и части Safari `viewTransition` по умолчанию ломает или подвисает навигацию
 * при использовании с BrowserRouter).
 */
export function useAppNavigate() {
  const navigate = useNavigate();

  return useCallback(
    (to: To | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        return navigate(to);
      }
      return navigate(to, options);
    },
    [navigate],
  );
}
